module.exports = __webpack_public_path__ + "static/media/1_pl.25bb3623.png";